import { Expose } from 'class-transformer';
import dobToAge from 'dob-to-age';

import { SnModel } from '@lib/common/models';

export class FsWhoosterPhoneModel extends SnModel {
  @Expose()
  public uuid: string;

  @Expose()
  public name: any[];

  @Expose()
  public relatives: any[];

  @Expose()
  public dob: any;

  @Expose()
  public address: string[];

  @Expose()
  public email: string[];

  constructor(data: any) {
    super();
    this.fromJSON(data);
    this.uuid = data?.uuid ? data?.uuid : data?.personToken;
    this.name = this.isArrays(data?.names?.name) ? data?.names?.name : [data?.names?.name];
    this.relatives = this.isArrays(data?.relatives?.relative)
      ? data?.relatives?.relative.map((item) => item?.name)
      : data?.relatives?.relative?.name;
    this.dob = this.isArrays(data?.DOBs?.DOB)
      ? this.calcBday(data?.DOBs?.DOB[0])
      : this.calcBday(data?.DOBs?.DOB);
    this.email = this.isArrays(data?.emails?.email) ? data?.emails?.email : [data?.emails?.email];
    this.address = this.isArrays(data?.addresses?.address)
      ? data?.addresses?.address.map((item) => this.formatAddress(item))
      : [this.formatAddress(data?.addresses?.address)];
  }

  public isArrays(item: any): boolean {
    return Array.isArray(item);
  }

  public formatAddress(items: any): any {
    let address = [];
    if (this.isArrays(items)) {
      address = items.map((item) => {
        return ` ${item?.line1}, ${item?.city}, ${item?.state}, ${item?.zip}`;
      });
    } else {
      address.push(`${items?.line1}, ${items?.city}, ${items?.state}, ${items?.zip}`);
    }
    return address;
  }

  public calcBday(bday: any): any {
    let age;
    if (bday?.month && bday?.day && bday?.year) {
      age = dobToAge(`${bday.month}/${bday.day}/${bday.year}`);
    } else if (bday?.month && !bday?.day && bday?.year) {
      age = dobToAge(`${bday.month}/1/${bday.year}`);
    } else if (!bday?.month && !bday?.day && bday?.year) {
      age = dobToAge(`1/1/${bday.year}`);
    } else {
      age = 'unknown';
    }
    return age;
  }
}
